export const USER_PROFILE_GROUPS_READ_REQUEST = 'USER_PROFILE_GROUPS_READ_REQUEST';
export const USER_PROFILE_GROUPS_READ_SUCCESS = 'USER_PROFILE_GROUPS_READ_SUCCESS';
export const USER_PROFILE_GROUPS_READ_FAILURE = 'USER_PROFILE_GROUPS_READ_FAILURE';

export const USER_PROFILE_GROUPS_ADD_REQUEST = 'USER_PROFILE_GROUPS_ADD_REQUEST';
export const USER_PROFILE_GROUPS_ADD_SUCCESS = 'USER_PROFILE_GROUPS_ADD_SUCCESS';
export const USER_PROFILE_GROUPS_ADD_FAILURE = 'USER_PROFILE_GROUPS_ADD_FAILURE';

export const USER_PROFILE_GROUPS_REMOVE_REQUEST = 'USER_PROFILE_GROUPS_REMOVE_REQUEST';
export const USER_PROFILE_GROUPS_REMOVE_SUCCESS = 'USER_PROFILE_GROUPS_REMOVE_SUCCESS';
export const USER_PROFILE_GROUPS_REMOVE_FAILURE = 'USER_PROFILE_GROUPS_REMOVE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/constants/user_profile_groups.constants.js